import { FormSchema } from '@precert/validation';
import React from 'react';
import { FormGroup } from 'reactstrap';

import InputField from '../../../../_components/input-field';

export interface StepClinicalNotesFormData {
  clinicalNotes: string;
}
export const StepClinicalNotesSchema = FormSchema().pick(['clinicalNotes']);

export const StepClinicalNotes = () => (
  <FormGroup>
    <InputField
      label="Notes"
      name="clinicalNotes"
      type="textarea"
      required={false}
      spellCheck
      autoResize
    />
  </FormGroup>
);

export const stepClinicalNotes = {
  title: 'Clinical Notes',
  schema: StepClinicalNotesSchema,
  element: <StepClinicalNotes />,
  path: 'clinical-notes',
};
